import { withPrefix } from "gatsby";

/**
 * Safely applies withPrefix to a URL, preserving anchor links
 * @param url - The URL to process
 * @returns The URL with prefix applied (except for anchor links)
 */
const withPrefixSafe = (url: string): string => {
  if (!url) return url;

  if (url.startsWith("#") || /^https?:\/\//i.test(url)) {
    return url;
  }

  return withPrefix(url);
};

export default withPrefixSafe;
